import { BrowserRouter } from "react-router-dom";
import { AppRoutes } from "./router";
import { I18nextProvider } from "react-i18next";
import i18n from "./i18n";
import { ExpenseProvider } from "@/store/ExpenseContext";
import { ToastProvider } from "@/store/ToastContext";

function App() {
  return (
    <I18nextProvider i18n={i18n}>
      <ExpenseProvider>
        <ToastProvider>
          <BrowserRouter basename={__BASE_PATH__}>
            <AppRoutes />
          </BrowserRouter>
        </ToastProvider>
      </ExpenseProvider>
    </I18nextProvider>
  );
}

export default App;